import React from "react";

const FilterRewardsCard = ({ 
  searchTerm, 
  countryId, 
  onSearchChange, 
  onCountryChange, 
  countries, 
  countriesLoading 
}) => {
  return (
    <div className="card rounded-4 shadow-sm">
      <div className="card-body">
        <div className="row add d-flex justify-content-between">
          <div className="col-md-3">
            <input
              type="text"
              className="form-control"
              placeholder="البحث باسم او معرف العميل..."
              value={searchTerm}
              onChange={onSearchChange}
            />   
          </div>
          <div className="col-md-2">
            <select 
              name="country" 
              id="country" 
              className="form-select"
              value={countryId}
              onChange={onCountryChange}
            >
              <option value="">الدولة</option>
              {countriesLoading ? (
                <option disabled>جارٍ تحميل الدول...</option>
              ) : (
                countries.map((country) => (
                  <option key={country.id} value={country.id}>
                    {country.name}
                  </option>
                ))
              )}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterRewardsCard;